"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _actions = require("../../redux/actions");

var _modelSelectorGraphql = _interopRequireDefault(require("../model-selector-graphql"));

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)({
      vehicleUpdateModelList: _actions.vehicleUpdateModelList,
      vehicleDelete: _actions.vehicleDelete,
      updateCurrentOrder: _actions.updateCurrentOrder,
      showHideVehicleList: _actions.showHideVehicleList
    }, dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config,
    selectedYear: state.compareSelection.selectedYear,
    selectedVehicle: state.compareSelection.selectedVehicle,
    selectedModels: state.compareSelection.selectedModels,
    models: state.compareSelection.models,
    market: state.Config.market,
    // unused
    language: state.Config.language,
    // unused
    countryCode: state.Config.market,
    // unused
    defaultLang: state.Config.defaultLang,
    // unused
    routePathMapping: state.routePathMapping,
    vehicleSelectedList: state.vehicleCompare.vehicleSelectedList
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_modelSelectorGraphql["default"]);

exports["default"] = _default;